<template>
  <dd-card-list-row>
    <dd-card-list-item title="Selectie beschrijving">
      <div class="search-descriptions">
        <div v-html="sanitize(searchDescription)"></div>
        <div v-for="extendingSearch in extendingSearchesDescriptions" :key="extendingSearch"
             v-html="sanitize(extendingSearch)"></div>
      </div>
    </dd-card-list-item>
    <dd-card-list-item v-if="total !== null" title="Aantal selectie resultaten">
      {{ total }} zoekresultaten
    </dd-card-list-item>
  </dd-card-list-row>
</template>

<script>
import automationApi from '~/api/automation'
import globalAutomationApi from '~/api/global_automation'
import { mapGetters, mapState } from 'vuex'
import debounce from 'lodash/debounce'
import DOMPurify from 'dompurify';

export default {
  name: 'AutomationSearchDescription',
  data () {
    return {
      searchDescription: '',
      extendingSearchesDescriptions: '',
    }
  },
  created () {
    this.initializeSearch()
  },
  watch: {
    automationKey () {
      this.initializeSearch()
    }
  },
  methods: {
    initializeSearch: debounce(function () {
      if (this.automationInterface === null) {
        return Promise.resolve({ search: '', extending_searches: '' })
      }

      // Deze check zit er in omdat als dit component eerst met een lokale automation wordt ingeladen en daarna
      // met een globale automation, dan staat in het automationInterface object nog kort de lokale
      // automation die geen global_automation_id heeft en wat een fout veroorzaakt.
      if (this.isGlobal && this.automationInterface.global_automation_id === undefined) {
        return
      }

      this.getSearchDescription()
        .then((response) => {
          this.searchDescription = response?.search
          this.extendingSearchesDescriptions = response?.extending_searches
        })
    }, 500),
    getSearchDescription () {
      if (this.isGlobal) {
        return globalAutomationApi.searchDescriptionByGlobalAutomation(this.automationInterface.global_automation_id)
      }
      return automationApi.searchDescriptionByAutomation(this.automationInterface.id)
    },
    sanitize(value) {
      return DOMPurify.sanitize(value)
    }
  },
  computed: {
    ...mapState(`$_automation_show`, [
      'searchablesPagination',
    ]),
    ...mapGetters(`$_automation_show`, [
      'automationKey',
      'automationInterface',
      'isGlobal',
    ]),
    total () {
      return this.searchablesPagination?.total
    }
  }
}
</script>

<style lang="scss">
.search-descriptions {
  display: flex;
  flex-direction: column;
  gap: 10px;

  ul.tree {
    padding-left: 0;
  }
}
</style>
